import { useEffect, useState } from "react";
import Edit from "@mui/icons-material/Edit";
import { AutocompleteInput, Button, ReferenceInput, required, useNotify, useRefresh } from "react-admin";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ReceptionTypeField = ({ onReceptionTypeChange }) => {
  const receptionTypeId = useWatch({ name: "receptionTypeId" });

  useEffect(() => {
    onReceptionTypeChange(receptionTypeId);
  }, [receptionTypeId, onReceptionTypeChange]);

  return (
    <ReferenceInput
      source="receptionTypeId"
      reference={administrationRequests.getReceptionTypesSelect()}
    >
      <AutocompleteInput
        optionText="name"
        label="Тип прием"
        fullWidth
        validate={required()}
      />
    </ReferenceInput>
  );
};

const ChangeReceptionTypeModal = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [receptionTypeId, setReceptionTypeId] = useState(record?.receptionTypeId);

  const handleSent = async data => {
    await dataProvider.customRequest(
      studentRequests.updateStudentReceptionType(record?.id),
      { receptionTypeId: data.receptionTypeId },
      "PUT",
    );
    refresh();
    notify("Успешна редакция на тип прием", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Редакция на тип прием"
      onConfirm={handleSent}
      defaultValues={{ receptionTypeId: record?.receptionTypeId }}
      confirmEnabled={!!receptionTypeId && receptionTypeId !== record?.receptionTypeId}
      resetProps={() => setReceptionTypeId(record?.receptionTypeId)}
      triggerButton={
        <Button
          label="Редакция на тип прием"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <ReceptionTypeField onReceptionTypeChange={setReceptionTypeId} />
    </FormModal>
  );
};

export default ChangeReceptionTypeModal;
